import React from "react"
import { Card } from "react-bootstrap"

const Content1 = () => {
  return (
    <Card>
      <Card.Body>
        <Card.Title>Core Engine</Card.Title>
        <Card.Subtitle className="mb-2 text-muted">Q1 2021</Card.Subtitle>
        <Card.Text>
          Finished working on the App core engine and the connection with Amazon
          SPAPI, Testing Stage started.
        </Card.Text>
      </Card.Body>
    </Card>
  )
}

export default Content1
